import Head from "next/head";
interface Props {
	children: React.ReactNode;
}
export default function CoverContainer(props: Props) {
	return (
		<>
			<Head>
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1.0, maximum-scale=1.0, viewport-fit=cover, user-scalable=no"
				/>
			</Head>
			{props.children}
		</>
	);
}
